const buildCountyFilterQuery = countyId => countyId
  ? {
      $or: [
        { district: countyId },
        { intersectingCounties: countyId },
      ],
    }
  : {};

export { buildCountyFilterQuery };
